function isEmptyString(string) {
  return !string.trim();
}

export { isEmptyString };
//# sourceMappingURL=is-empty-string.js.map
